import { createFileRoute, Navigate, useSearch } from '@tanstack/react-router';
import styled from 'styled-components';
import { useCurrentUser } from '~/hooks/useCurrentUser';
import { LoadingSpinner } from '~/modules/common/LoadingSpinner';
import { SearchResultsPage } from '~/modules/search/SearchResultsPage';
import {
  isGlobalSearchMode,
  validateGlobalSearchParams,
} from '~/modules/search/searchParams';

export const Route = createFileRoute('/_app/')({
  validateSearch: validateGlobalSearchParams,
  component: Index,
});

function Index() {
  const { me, isStudent, isStudyHelper } = useCurrentUser();
  const searchParams = useSearch({ from: '/_app/' });
  const searchTerm = searchParams.s?.trim() ?? '';
  const shouldRenderSearch = isGlobalSearchMode(searchParams) && !!searchTerm;

  if (!me) {
    return (
      <CenteredContainer>
        <LoadingSpinner />
      </CenteredContainer>
    );
  }

  if (shouldRenderSearch) {
    return <SearchResultsPage term={searchTerm} isStudent={isStudent} />;
  }

  if (isStudent) {
    return (
      <Navigate
        to="/members/$memberId/"
        params={{ memberId: me.id.toString() }}
      />
    );
  }

  if (isStudyHelper) {
    if (me.group?.slug) {
      return (
        <Navigate
          to="/groups/$groupName/"
          params={{ groupName: me.group.slug }}
        />
      );
    }
    return null;
  }

  return null;
}

const CenteredContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 100px);
`;
